/* vnf-forms v1 · Oct 28 2026 · Volty ID native forms (replace Globo Form Builder on voltyid.com).
   Every form[data-vnf] on the page:
     1. checks the required fields,
     2. saves to the site-forms backend (stored, sorted by AI, assigned to Angelo, HubSpot ticket or lead),
     3. shows the thank-you only once the save succeeded (it is the only channel; there is no browser email here).
   Also sends the /pages/quiz email step (it used to keep the email in page memory only) as volty_quiz.
   Submissions from an unpublished (preview) theme are saved as tests: no HubSpot, no emails. */
(function () {
  if (window.VNF) return;
  var API = 'https://ekpavfdzsrfathpwjrwu.supabase.co/functions/v1/site-forms';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE = '(877) 600-1120';
  var isTest = function () { return !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'); };

  // resolves { ok, error }
  function send(key, fields, t) {
    var body = JSON.stringify({ form: key, page: location.pathname + location.search, hp: '', t: t, test: isTest(), fields: fields });
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true })
      .then(function (r) { return r.json(); })
      .then(function (j) { return { ok: !!(j && j.ok), error: j && j.error ? String(j.error) : null }; })
      .catch(function () { return { ok: false, error: null }; });
  }
  window.VNF = { v: 1, send: send };

  function values(form) {
    var out = {}, els = form.querySelectorAll('input[name], select[name], textarea[name]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.name === 'vnf_hp') continue;
      if (el.type === 'radio') { if (el.checked) out[el.name] = el.value; }
      else if (el.type === 'checkbox') out[el.name] = el.checked ? 'yes' : (out[el.name] || 'no');
      else out[el.name] = String(el.value || '').trim();
    }
    return out;
  }

  function check(form) {
    var bad = null, req = form.querySelectorAll('[required]');
    for (var i = 0; i < req.length; i++) {
      var el = req[i], ok = !!String(el.value || '').trim();
      if (ok && el.type === 'email') ok = EMAIL_RE.test(el.value.trim());
      var w = el.closest('.vnf-f'); if (w) w.classList.toggle('vnf-bad', !ok);
      if (!ok && !bad) bad = el;
    }
    return bad;
  }

  function done(form) {
    var box = document.createElement('div');
    box.className = 'vnf-done' + (form.classList.contains('vnf--dark') ? ' vnf--dark' : '');
    box.setAttribute('role', 'status');
    box.innerHTML = '<div class="vnf-ok" aria-hidden="true">✓</div><p class="vnf-done-t"></p><p class="vnf-done-m"></p>';
    box.querySelector('.vnf-done-t').textContent = form.getAttribute('data-ok-title') || 'Thank you!';
    box.querySelector('.vnf-done-m').textContent = form.getAttribute('data-ok-msg') || 'We will get back to you soon.';
    form.parentNode.replaceChild(box, form);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'vnf_submit', form_name: form.getAttribute('data-vnf') });
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form_name: form.getAttribute('data-vnf') });
    } catch (e) {}
  }

  function bind(form) {
    if (form.__vnf) return; form.__vnf = true;
    var t0 = Date.now(), msg = form.querySelector('.vnf-msg');
    var clear = function (e) { var w = e.target.closest && e.target.closest('.vnf-bad'); if (w) w.classList.remove('vnf-bad'); };
    form.addEventListener('input', clear);
    form.addEventListener('change', clear);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.__sending) return;
      var bad = check(form);
      if (bad) {
        if (msg) { msg.hidden = false; msg.textContent = bad.type === 'email' && bad.value.trim() ? 'Please check your email address.' : 'Please fill in the highlighted fields.'; }
        try { bad.focus(); } catch (x) {}
        return;
      }
      if (msg) msg.hidden = true;
      var hp = form.querySelector('[name="vnf_hp"]');
      if ((hp && hp.value) || Date.now() - t0 < 2500) { done(form); return; }
      form.__sending = true;
      var btn = form.querySelector('[type="submit"]'), label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Sending…</span>'; }
      send(form.getAttribute('data-vnf'), values(form), Date.now() - t0).then(function (r) {
        if (r.ok) { done(form); return; }
        form.__sending = false;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (msg) { msg.hidden = false; msg.textContent = r.error || ('Something went wrong sending your request. Please try again, or call ' + PHONE + '.'); }
      });
    });
  }

  // /pages/quiz: the "See My Printer" step. Same pick as the quiz's own resolveVariant().
  function quiz() {
    var btn = document.getElementById('submit-quiz'), input = document.getElementById('quiz-email');
    if (!btn || !input || btn.__vnf) return;
    btn.__vnf = true;
    var t0 = Date.now(), sent = false;
    var pick = function (n) { var r = document.querySelector('.quiz-step input[name="' + n + '"]:checked'); return r ? r.value : ''; };
    btn.addEventListener('click', function () {
      var email = String(input.value || '').trim();
      if (sent || !EMAIL_RE.test(email)) return;
      sent = true;
      var a = { cards_per_year: pick('cardsPerYear'), sides: pick('sides'), computer: pick('computer'), connection: pick('connection'), printer_type: pick('printerType') };
      a.recommended = a.printer_type === 'Retransfer' || a.sides === 'Double' ? 'VX300' : (a.cards_per_year === '201-500' || a.cards_per_year === 'Over 500') ? 'VX200' : 'VX100';
      a.email = email;
      a.message = 'Took the printer quiz and was matched to the ' + a.recommended + '. Answers: ' + [a.cards_per_year + ' cards a year', a.sides + ' sided', a.computer, a.connection, a.printer_type].filter(Boolean).join(', ') + '.';
      send('volty_quiz', a, Math.max(Date.now() - t0, 3000));
    }, true);
  }

  function init() {
    var fs = document.querySelectorAll('form[data-vnf]');
    for (var i = 0; i < fs.length; i++) bind(fs[i]);
    quiz();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
